var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',_vm._b({},'v-icon',_vm.$attrs,false),[_vm._v("la-user-friends")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }